import { useMemo, useState } from "react";
import ProductCard from "../components/ProductCard";
import products from "../data/products";

export default function Products() {
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("All");
  const [sort, setSort] = useState("relevant");

  const categories = useMemo(() => ["All", ...new Set(products.map(p => p.category))], []);

  const filtered = useMemo(() => {
    let arr = products.filter(p => {
      const matchQ =
        p.name.toLowerCase().includes(q.toLowerCase()) ||
        p.tags?.some(t => t.toLowerCase().includes(q.toLowerCase()));
      const matchCat = category === "All" || p.category === category;
      return matchQ && matchCat;
    });

    if (sort === "priceLow") arr = arr.slice().sort((a,b) => a.price - b.price);
    if (sort === "priceHigh") arr = arr.slice().sort((a,b) => b.price - a.price);
    if (sort === "name") arr = arr.slice().sort((a,b) => a.name.localeCompare(b.name));
    // "relevant" keeps original order
    return arr;
  }, [q, category, sort]);

  const handleAdd = (product) => {
    alert(`Added to cart: ${product.name}`); // replace with real cart later
  };

  return (
    <section className="section products-page">
      <h2>Products</h2>

      <div className="filters">
        <input
          type="search"
          placeholder="Search products, e.g., silk, kurti…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label="Search products"
        />

        <select value={category} onChange={(e) => setCategory(e.target.value)} aria-label="Filter by category">
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>

        <select value={sort} onChange={(e) => setSort(e.target.value)} aria-label="Sort products">
          <option value="relevant">Sort: Relevant</option>
          <option value="priceLow">Price: Low to High</option>
          <option value="priceHigh">Price: High to Low</option>
          <option value="name">Name: A–Z</option>
        </select>
      </div>

      <div className="products-grid">
        {filtered.map(p => (
          <ProductCard key={p.id} product={p} onAdd={handleAdd} />
        ))}
        {filtered.length === 0 && (
          <div className="empty-state">
            No products found. Try a different search or filter.
          </div>
        )}
      </div>
    </section>
  );
}
